// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------
import { createEnum } from "@cartographerio/util";
const DisturbedBankFace = "DisturbedBankFace";
const OverlandFlow = "OverlandFlow";
const Ditch = "Ditch";
const Pipe = "Pipe";
const Culvert = "Culvert";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const MrsMudSpotterSourceTypeEnum = {
    ...createEnum("MrsMudSpotterSourceType", [
        [DisturbedBankFace, "Disturbed Bank Face"],
        [OverlandFlow, "Overland Flow"],
        [Ditch, "Ditch"],
        [Pipe, "Pipe"],
        [Culvert, "Culvert"],
    ]),
    DisturbedBankFace,
    OverlandFlow,
    Ditch,
    Pipe,
    Culvert,
};
null;
null;
export default MrsMudSpotterSourceTypeEnum;
//# sourceMappingURL=MrsMudSpotterSourceTypeEnum.generated.js.map